import type { BannerAdProvider } from "./adPorts.js";
import { shouldShowBanner } from "./bannerVisibility.js";

export interface BannerControllerDeps {
  readonly provider: BannerAdProvider;
  readonly isNative: boolean;
  readonly featureEnabled: () => boolean;
  readonly adFree: () => boolean;
}

export class BannerController {
  constructor(private readonly deps: BannerControllerDeps) {}

  evaluate(): void {
    const show = shouldShowBanner({
      isNative: this.deps.isNative,
      featureEnabled: this.deps.featureEnabled(),
      adFree: this.deps.adFree(),
    });
    if (show) this.deps.provider.showBanner();
    else this.deps.provider.removeBanner();
  }
}
